const particularPersonTabMapping = {
    1: "secondClientPerson",
    2: "thirdClientPerson",
    3: "fourthClientPerson"
};

const companyPersonTabMapping = {
    1: "secondClientCompany",
    2: "thirdClientCompany",
    3: "fourthClientCompany"
};

export { particularPersonTabMapping, companyPersonTabMapping };